export default __webpack_public_path__ + "static/M12-9503f4f5d6ceffc89408d31e2823eb18.png";